import { useState } from 'react';
import { createTicket as createTicketAPI } from "../lib/ticket.js"
import { NrlkException } from '../model/exception.js';

/**
 * Fournit une fonction `create(ticketData)` pour créer un ticket et expose `{ create, loading, error }`.
 *
 * @returns {{ create: Function, loading: boolean, error: string|null }}
 */
export const useCreateTicket = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const create = async (ticketData) => {
    setLoading(true);
    setError(null);

    try {
      const ticket = await createTicketAPI(
        ticketData.idClient,
        ticketData.titre,
        ticketData.description,
        ticketData.priorite,
        ticketData.dateDebut,
        ticketData.dateFin,
        ticketData.idStatut,
        ticketData.idType,
        ticketData.intervenant,
        ticketData.intervention,
        ticketData.idFacturant,
        ticketData.modeFacturation,
        ticketData.custom,
        ticketData.envoyerMail,
        ticketData.mailClient
      );
      return ticket;
    } catch (err) {
      if (err instanceof NrlkException) {
        setError(err.message);
      } else {
        setError("Une erreur inconnue est survenue");
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, error };
};
